import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Drawer from '../MyComponents/Drawer/Drawer';
import LessonDrawer from '../MyComponents/Drawer/LessonDrawer';
import ShareDialog from '../MyComponents/Drawer/ShareDialog';
import JoinRequestDialog from '../MyComponents/Drawer/JoinRequestDialog';
import LessonPagePickerDialog from '../MyComponents/Drawer/LessonPagePickerDialog';
import RequestFullScreen from '../MyComponents/Drawer/RequestFullScren';
import MultiBoardDialog from '../MyComponents/Drawer/MultiBoardDialog';
import JoinCallDialog from '../MyComponents/Drawer/JoinCallDialog';
import StaticPageNavigatorDialog from '../MyComponents/Drawer/StaticPageNavigatorDialog';
import UpgradeSubscriptionDialog from '../MyComponents/Drawer/UpgradeSubscriptionDialog';
import { COLORS2 } from '../constants';
import ConsentDialog from '../MyComponents/ConsentDialog/ConsentDialog';

const wrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflow: 'hidden',
};

// The page routes use `clip` rather than `hidden`: hidden makes this element a
// scroll container, which stops sticky content (the tutorial's table of
// contents) from pinning to the viewport. `clip` still suppresses the
// horizontal overflow this was added for. The lesson route keeps `hidden`.
const pageWrapperStyle = {
    ...wrapperStyle,
    overflow: undefined,
    overflowX: 'clip',
    backgroundColor: COLORS2.virtualBackground,
};

export default function AuthenticatedApp({ language, updateLanguage }) {
    return (
        <>
            <Switch>
                <Route path="/lesson/:classId">
                    <div style={wrapperStyle}>
                        <LessonDrawer updateLanguage={updateLanguage} />
                    </div>
                </Route>
                <Route path="*">
                    <div style={pageWrapperStyle}>
                        <Drawer updateLanguage={updateLanguage} language={language} />
                    </div>
                </Route>
            </Switch>
            <JoinRequestDialog />
            <ShareDialog />
            <UpgradeSubscriptionDialog />
            <JoinCallDialog />
            <MultiBoardDialog />
            {/* <NewFeatureDialog /> */}
            <LessonPagePickerDialog />
            <RequestFullScreen />
            <StaticPageNavigatorDialog />
            <ConsentDialog />
        </>
    );
}
